export default (value) => value.split('').reverse().join('')



// WEBPACK FOOTER //
// ./src/filters/reverse.js